import { RefObject } from "react"
import { Message } from "./types"
import { ChatMessage } from "./ChatMessage"

interface ChatMessagesProps {
  messages: Message[]
  messagesEndRef: RefObject<HTMLDivElement | null>
  sessionId: string
  isLoading?: boolean
  onFeedbackSubmit: (
    messageContent: string,
    feedbackType: "positive" | "negative",
    comment: string
  ) => Promise<void>
  onQuickAction?: (action: string) => void
}

export function ChatMessages({
  messages,
  messagesEndRef,
  sessionId,
  isLoading,
  onFeedbackSubmit,
  onQuickAction,
}: ChatMessagesProps) {
  const lastAssistantIndex = messages.reduce(
    (last, msg, i) => (msg.role === "assistant" ? i : last),
    -1
  )

  return (
    <div
      className={`h-full p-4 space-y-4 w-full ${
        messages.length > 0 ? "overflow-y-auto" : "overflow-hidden"
      }`}
    >
      {messages.length === 0 ? (
        <div className="flex items-center justify-center h-full text-gray-400">
          Start a new conversation
        </div>
      ) : (
        messages.map((message, index) => (
          <ChatMessage
            key={index}
            message={message}
            sessionId={sessionId}
            isLastAssistant={index === lastAssistantIndex}
            isLoading={isLoading}
            onFeedbackSubmit={async (feedbackType, comment) => {
              await onFeedbackSubmit(message.content, feedbackType, comment)
            }}
            onQuickAction={onQuickAction}
          />
        ))
      )}
      {/* Typing indicator */}
      {isLoading && messages.length > 0 && messages[messages.length - 1]?.content === "" && (
        <div className="flex gap-3">
          <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-semibold bg-emerald-500 flex-shrink-0">
            T
          </div>
          <div className="flex items-center gap-1 py-3 text-gray-400">
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  )
}
